export default __webpack_public_path__ + "static/media/leaderboard-icon.93401265.png";